module.exports = __webpack_public_path__ + "static/media/CreditCardsIcon.ee6af70e.svg";